import 'jquery.cookie';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';

import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => {
    const options = {
        cache: false,
        data: {
            ...tourCriteriaForTourRequest,
            abTests: getABTestValue(),
        },
        type: 'POST',
        url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers/asyncSearch`,
    };

    return requestService(options, callback);
};